import { Widget, WidgetEditor } from 'jamespot-front-business';
import { DashedFocusBorder } from 'jamespot-react-components';
import { WidgetKeys } from 'jamespot-user-api';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { useAppDispatch } from '../../redux/store';
import { commonComponentsRegistry } from '../../registry/CommonRegistry';

const JRCHtml = commonComponentsRegistry.getLazyComponent('Html');

export const WrapperEditMode = styled.button`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: ${(props) => props.theme.space.md}px;
    color: ${(props) => props.theme.color.primary};
    cursor: pointer;
    opacity: 0;
    border: 1px solid ${(props) => props.theme.color.primary};
    &:hover {
        background-color: ${(props) => props.theme.color.grey2};
        opacity: 0.9;
    }

    ${DashedFocusBorder()}
`;

export const WidgetWrapperCoreEditHover = ({ uniqid, name }: { uniqid: string; name: WidgetKeys }) => {
    const dispatch = useAppDispatch();
    const intl = useIntl();

    const registerEditor = useCallback(() => {
        dispatch(WidgetEditor.slice.actions.flushAllEditor());
        dispatch(
            WidgetEditor.slice.actions.registerEditor({
                uniqid,
                name,
            }),
        );
    }, [dispatch, uniqid, name]);
    const def = Widget.definition(name);

    return (
        <WrapperEditMode onClick={registerEditor}>
            <JRCHtml
                __html={`${intl.formatMessage({ id: 'WIDGET_Set_Widget' })} <b>${intl.formatMessage({
                    id: def.label,
                })}</b>`}
            />
        </WrapperEditMode>
    );
};
